<template>
  <div class="app-container">
    <!-- pc端模式 -->
    <div class="home-container" v-if="!isMobile">
      <div class="aside" :class="[isShowNav ? '' : 'hide-nav']">
        <navMenu @changeRouter="changeNav"></navMenu>
      </div>
      <!-- 收起导航栏 -->
      <div class="open-btn" :class="[isShowNav ? '' : 'open-btn-left']" @click="changeNavShow">
        <img :class="[isShowNav ? '' : 'arrow-to-right']" src="@/assets/img/left-arrow.png" />
      </div>
      <div class="homeMain" :class="[isShowNav ? '' : 'home-main-100']">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
    <!-- app模式 -->
    <div class="home-container-mobile" v-else>
      <AppHomeContainer ref="AppHomeContainer" />
    </div>
  </div>
</template>

<script>
import AppHomeContainer from '@/views/app/home/Home.vue'

export default {
  components: {
    AppHomeContainer
  },
  data() {
    return {
      // 是否显示侧边栏
      isShowNav: true
    }
  },
  methods: {
    changeNav(item) {
      const curRoute = this.$route.path
      const toRoute = item.path
      // 点击了当前已选中的路由，则不跳转
      if (curRoute === '/' + toRoute) {
        return
      }
      this.$router.replace(toRoute)
    },
    // 切换导航栏收缩状态
    changeNavShow() {
      this.isShowNav = !this.isShowNav
    }
  },
  computed: {
    // 是否是移动端
    isMobile() {
      return this.$store.state.isMobile
    }
  }
}
</script>

<style lang="less" scoped>
.app-container {
  width: 100%;
  height: 100%;
}
.home-container {
  display: flex;
}
.aside {
  width: @aside-width;
  height: 100vh;
  transition: @slow-transition;
  opacity: 1;
  // z-index: 1; 不用写这个  写这个会导致页面图层顺序乱掉
}

.homeMain {
  width: calc(100% - @aside-width);
  overflow: hidden;
  // 注意！transition: 0.5s 才不会导致在侧边栏展开时发生抖动，经测验得出的参数，不可随意修改！
  transition: 0.5s ease;
}

.home-main-100 {
  overflow: hidden;
  transition: @normal-transition;
  width: 100%;
}

// 控制侧边栏显隐
.open-btn {
  position: absolute;
  width: 15px;
  height: 60px;
  border-radius: 5px;
  background-color: #9cc2ff;
  top: 30%;
  // ↓ 侧边栏贴边的样式
  // left: calc(@aside-width - 10px);
  // ↑ 侧边栏贴边的样式

  // ↓ 侧边栏不贴边的样式
  left: calc(@aside-width - 5px);
  // ↑ 侧边栏不贴边的样式
  transition: @slow-transition;
  box-shadow: #efefef -0px 0px 5px 2px;
  z-index: 2;

  .fl;
  > img {
    width: 12px;
    height: 15px;
    transition: @normal-transition;
  }

  .arrow-to-right {
    transform: rotate(180deg);
    transition: @normal-transition;
  }
}

.open-btn-left {
  left: 0;
  transition: @slow-transition;
  height: 150px;
  width: 15px;
  border-radius: 5px;
  opacity: 0.7;
}

.open-btn:hover,
open-btn-left:hover {
  cursor: pointer;
  background-color: #71a7ff;
}

.hide-nav {
  transition: @slow-transition;
  width: 0;
  opacity: 0;
}
</style>
